export default "__VITE_ASSET__DgcKeaXn__"